import type { FunctionComponent } from 'react';
import React from 'react';

import type { FieldInterface } from './Field/Field';
import { Field } from './Field/Field';

type FieldListProps = {
  fields?: FieldInterface[];
};

const FieldList: FunctionComponent<FieldListProps> = ({ fields = [] }) => {
  const renderField = (field: FieldInterface) => (
    <Field field={field} key={field.id} />
  );

  const list = fields.map(renderField);

  return <div className="FlexGrid FlexGrid--fromMedium-2 gap-y-8">{list}</div>;
};

export { FieldList };
